import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Webnar } from 'src/app/models/webnar';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-webnar-view-dialog',
  templateUrl: './webnar-view-dialog.component.html',
  styleUrls: ['./webnar-view-dialog.component.scss']
})
export class WebnarViewDialogComponent implements OnInit {
  public path_url: any;


  constructor(
    public _sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: Webnar) { }

  ngOnInit() {

    let url = this.data.url
    this.path_url = this._sanitizer.bypassSecurityTrustResourceUrl(url)

  }

}
